import React from 'react';
import { ViewAllFAQButton, ViewAllFAQContainer } from './ViewAllFAQButtonStyle';
import { redirectUser } from '../../../../utils/navigation';

interface IButtonProps {
  content: string;
  redirect: string;
}

export const ViewAllFAQButtonContainer = ({ content, redirect }: IButtonProps) => {
  return (
    <ViewAllFAQContainer
      beforeContent={content}
      onClick={() => redirectUser(redirect)}>
          <ViewAllFAQButton>{content}</ViewAllFAQButton>
    </ViewAllFAQContainer>
  );
};

